import { render, staticRenderFns } from "./topMsg.vue?vue&type=template&id=69147180&scoped=true"
import script from "./topMsg.vue?vue&type=script&lang=js"
export * from "./topMsg.vue?vue&type=script&lang=js"
import style0 from "./topMsg.vue?vue&type=style&index=0&id=69147180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69147180",
  null
  
)

export default component.exports